/**  teacher actions constants */
export const SET_LIST_STUDENT = 'student/SET_LIST_STUDENT';